<template>
	<PlusButtonComponent
		v-if="isAdminEfChampion && school"
		:active="isInDashboardTodo(resource.ID)"
		:title="`Add this resource to the dashboard for ${school.post_title}.`"
		@click="handleClick"
	/>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue';
import { mapActions, mapState } from 'pinia';
import PlusButtonComponent from '@/components/buttons/PlusButtonComponent.vue';
import { useDashboardStore } from '@/stores/dashboardStore';
import { useUser } from '@/stores/userStore';
import { resourceStatusKeys } from '@/interfaces/resourceStatusInterface';
import type { Resource } from '@/interfaces/resourceInterface';

export default defineComponent({
	components: { PlusButtonComponent },
	props: {
		resource: {
			type: Object as PropType<Resource>,
			required: true,
		},
	},
	computed: {
		...mapState(useUser, ['school', 'isAdminEfChampion']),
	},
	methods: {
		handleClick() {
			if (this.isInDashboardTodo(this.resource.ID)) {
				this.removeResource(this.resource, resourceStatusKeys.Todo);
			} else {
				this.addResource(this.resource, false);
			}
		},
		...mapActions(useDashboardStore, ['isInDashboardTodo', 'removeResource', 'addResource']),
	},
});
</script>
